module.exports = __webpack_public_path__ + "static/media/commentArtboard 1@1.5x.986418f4.png";